'use client';

import React from 'react';
import { Modal, Button, Form, Row, Col, Card, Badge } from 'react-bootstrap';
import Icon from '../Icon';
import { faUser, faChartPie, faLayerGroup } from '@fortawesome/free-solid-svg-icons';
import { LifePart } from '../../state/LifePart';

interface ReflectionSectionsModalProps {
    show: boolean;
    onHide: () => void;
    onSave: (sectionType: 'me' | 'balance' | 'lifepart' | 'lifepart-all', lifepartUuid?: string) => void;
    availableSections: { 
        me: boolean; 
        balance: boolean;
        lifeparts?: LifePart[]; // все доступные LifePart из снимков
    };
    selectedLifeparts?: string[]; // уже выбранные UUID
}

export default function ReflectionSectionsModal({
    show,
    onHide,
    onSave,
    availableSections,
    selectedLifeparts = []
}: ReflectionSectionsModalProps) {
    
    const handleLifepartToggle = (uuid: string) => {
        onSave('lifepart', uuid);
    };

    const handleSelectAll = () => {
        onSave('lifepart-all');
    };

    const lifepartsList = availableSections.lifeparts || [];

    return (
        <Modal show={show} onHide={onHide} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Добавить данные в рефлексию</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="d-flex flex-column gap-4">
                    {/* Блок "Кто я и Моя миссия" */}
                    {availableSections.me && (
                        <Card className="border-0 shadow-sm">
                            <Card.Body>
                                <Form.Check
                                    type="checkbox"
                                    id="me-section"
                                    label={
                                        <div className="d-flex align-items-center">
                                            <Icon icon={faUser} className="me-2 text-secondary" style={{ fontSize: '1.2rem' }} />
                                            <div>
                                                <strong>Кто я и Моя миссия</strong>
                                                <div className="text-muted small">Динамика самоощущения и миссии</div>
                                            </div>
                                        </div>
                                    }
                                    onChange={() => onSave('me')}
                                />
                            </Card.Body>
                        </Card>
                    )}

                    {/* Блок "Баланс" */}
                    {availableSections.balance && (
                        <Card className="border-0 shadow-sm">
                            <Card.Body>
                                <Form.Check
                                    type="checkbox"
                                    id="balance-section"
                                    label={
                                        <div className="d-flex align-items-center">
                                            <Icon icon={faChartPie} className="me-2 text-secondary" style={{ fontSize: '1.2rem' }} />
                                            <div>
                                                <strong>Баланс (колеса)</strong>
                                                <div className="text-muted small">Снимки колеса баланса на начало и конец периода</div>
                                            </div>
                                        </div>
                                    }
                                    onChange={() => onSave('balance')}
                                />
                            </Card.Body>
                        </Card>
                    )}

                    {/* Блок "Сферы жизни" */}
                    {lifepartsList.length > 0 && (
                        <Card className="border-0 shadow-sm">
                            <Card.Header className="bg-transparent d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <Icon icon={faLayerGroup} className="me-2 text-secondary" style={{ fontSize: '1.2rem' }} />
                                    <strong>Сферы жизни</strong>
                                </div>
                                <Button
                                    variant="outline-primary"
                                    size="sm"
                                    onClick={handleSelectAll}
                                >
                                    Выбрать все
                                </Button>
                            </Card.Header>
                            <Card.Body>
                                <Row className="g-2">
                                    {lifepartsList.map((lp) => {
                                        const isSelected = selectedLifeparts.includes(lp.uuid);
                                        return (
                                            <Col key={lp.uuid} xs={6} md={4}>
                                                <Form.Check
                                                    type="checkbox"
                                                    id={`lifepart-${lp.uuid}`}
                                                    label={
                                                        <div className="d-flex align-items-center gap-2">
                                                            <div
                                                                className="rounded-circle"
                                                                style={{
                                                                    width: '12px',
                                                                    height: '12px',
                                                                    backgroundColor: lp.color
                                                                }}
                                                            />
                                                            <span className="small">{lp.name}</span>
                                                        </div>
                                                    }
                                                    checked={isSelected}
                                                    onChange={() => handleLifepartToggle(lp.uuid)}
                                                />
                                            </Col>
                                        );
                                    })}
                                </Row>
                            </Card.Body>
                        </Card>
                    )}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Закрыть
                </Button>
            </Modal.Footer>
        </Modal>
    );
}